// export const BASE_URL = `https://api.escuelajs.co/api/v1/`;
export const BASE_URL = `https://dummyjson.com/`;
